import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { StarRating } from '@/components/Primitives';

export default function ReviewPage() {
  const { paymentId } = useParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [punctuality, setPunctuality] = useState(5);
  const [communication, setCommunication] = useState(5);
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (rating < 1) return toast.error('Choisissez une note');
    setSubmitting(true);
    try {
      await api.post('/reviews', {
        job_id: paymentId,
        rating,
        comment,
        punctuality: user?.role === 'jobeur' ? punctuality : null,
        communication: user?.role === 'jobeur' ? communication : null,
      });
      toast.success('Avis publié — merci !');
      nav('/dashboard');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur');
    } finally { setSubmitting(false); }
  };

  return (
    <div className="max-w-xl mx-auto px-4 md:px-6 py-6">
      <h1 className="text-2xl font-bold mb-2">Laisser un avis</h1>
      <p className="text-sm text-slate-600 mb-4">Votre avis aide la communauté à faire confiance.</p>
      <Card className="p-4 space-y-4">
        <div>
          <p className="text-sm font-medium mb-1">Note globale</p>
          <StarRating value={rating} onChange={setRating} size={28} />
        </div>
        {user?.role === 'jobeur' && (
          <>
            <div>
              <p className="text-sm font-medium mb-1">Ponctualité du client</p>
              <StarRating value={punctuality} onChange={setPunctuality} size={22} />
            </div>
            <div>
              <p className="text-sm font-medium mb-1">Communication</p>
              <StarRating value={communication} onChange={setCommunication} size={22} />
            </div>
          </>
        )}
        <div>
          <p className="text-sm font-medium mb-1">Commentaire</p>
          <Textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Partagez votre expérience…" rows={5} data-testid="review-comment" />
        </div>
        <Button onClick={submit} disabled={submitting} className="w-full bg-[#1677F2] hover:bg-[#0F5FCC]" data-testid="review-submit-btn">
          {submitting ? 'Publication…' : 'Publier mon avis'}
        </Button>
      </Card>
    </div>
  );
}
